module.exports = __webpack_public_path__ + "static/media/step-1-icon.29854264.svg";